import { recordNREvent } from "@checkout-core/newrelic";
import { NEWRELIC_TABLES } from "@checkout-core/constants/NewRelicTables";

interface CustomTrackingPayload {
    [key: string]: any;
}

/**
 * Records a custom tracking event to New Relic
 * @param payload The tracking payload
 * @param batch Whether to batch the event (default: true)
 
 * will remove after a month once debugging is over
 */
export const recordCustomTrackingNREvent = (payload: CustomTrackingPayload): void => {
    recordNREvent({
        eventType: NEWRELIC_TABLES.CUSTOM_TRACKING_EVENT,
        ...payload,
    });
};
